module.exports = __webpack_public_path__ + "static/media/instapay_qr_logo.82b2def8.png";